import { useWebsocketOrThrow } from "@soft-db/monitoring-api-client";
import { defineStore } from "pinia";
import { useAuthStore } from "./auth";

export const useWebsocketStore = defineStore("websocket", () => {
	// Using shallowRef to prevent pinia from making the object deeply reactive,
	// which break since it's a class with private fields
	const socket = shallowRef(useWebsocketOrThrow());

	const authStore = useAuthStore();

	watch(
		() => authStore.isAuth,
		(isAuth) => {
			if (isAuth) {
				socket.value.connect();
			} else {
				socket.value.disconnect();
			}
		},
		{ immediate: true }
	);

	return { socket };
});
